export default __webpack_public_path__ + "static/media/design-active.876e940e.svg";